import { LoadingOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Select, Steps } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useHistory } from "react-router-dom";
import { signUpApi } from "../../../api/signUpApi";
import logo from "../../../assets/icon/logo.png";
import { country } from "../../../helper/constant/countryCode";
import { LoginContext } from "../../../store/loginStore";
import SignupModal from "./signupModal";
import Footer from "../footer/footer";
const { Step } = Steps;
const { Option } = Select;

export default function SignUp() {
  const history = useHistory();
  const sch_code = localStorage.getItem("sch_code");
  const [currentStep, setCurrentStep] = useState(0);
  const [collectData, setCollectData] = useState({ sch_code });
  const [isPolicyModal, setIsPolicyModal] = useState(false);

  const [form] = Form.useForm();

  const { loginC, dispatchLogin } = LoginContext();

  const { supportData, loader } = loginC;

  const getCollectedData = (data) => {
    const year = moment().diff(data.age, "years");
    const month = moment().diff(data.age, "months") % 12;
    const dob = data.age && data.age.format("YYYY-MM-DD");
    const age = `${year}-${month}`;
    const myData = data.age
      ? { ...collectData, dob, age }
      : { ...collectData, ...data };

    setCollectData(myData);
  };

  const handleNext = (data) => {
    setCurrentStep((prev) => prev + 1);
    getCollectedData(data);
  };

  const handleSubmit = (value) => {
    getCollectedData(value);
    setIsPolicyModal(true);
  };

  const YearBack5 = moment().subtract(5, "years");
  function disabledDate(current) {
    return current && current > YearBack5;
  }
  const handleCountryCode = (countryCode) => {
    const code = countryCode.split("+");
    return code[1];
  };

  const countryFlagImg = (code) => {
    let cCode = code.split("-").join("_");
    cCode = handleCountryCode(cCode);

    return (
      <img
        style={{ width: 36 }}
        src={require(`../../../assets/img/countryFlag/flag_${cCode}.png`)}
        alt=""
        className=""
      />
    );
  };

  const steps = [
    {
      content: (
        <>
          <h2>Please tell me your name</h2>
          <Form.Item
            name="firstname"
            rules={[
              {
                max: 32,
                message: "Only 32 letters allow to input",
              },
              {
                required: true,
                message: "Please input your First Name",
              },
              {
                pattern: /^([a-zA-Z]{2,})?$/,
                message: "space, number or any special character not allowed",
              },
            ]}
          >
            <Input placeholder="First Name*" className="custom-input" />
          </Form.Item>

          <Form.Item
            name="lastname"
            rules={[
              {
                max: 32,
                message: "Only 32 letters allow to input",
              },
              {
                required: true,
                message: "Please input your Last Name",
              },
              {
                pattern: /^([a-zA-Z]{2,})?$/,
                message: "space, number or any special character not allowed",
              },
            ]}
          >
            <Input placeholder="Last Name*" className="custom-input" />
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Enter a parent/guardian email</h2>
          <Form.Item
            name="email"
            rules={[
              {
                max: 64,
                message: "Only 64 letters allow to input",
              },
              {
                required: true,
                message: "Please input your Email address",
              },
              {
                pattern:
                  /^([a-zA-Z\d_.-]{2,})@([a-zA-Z\d-]{2,})\.([a-zA-Z]{2,})(\.[a-zA-Z]{2,})?$/,
                message: "Please input correct Email address",
              },
              {
                pattern: /^\S+$/,
                message: "space not allowed",
              },
            ]}
          >
            <Input placeholder="Parent's Email" className="custom-input" />
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Which school are you from?</h2>
          <Form.Item name="sch_name" initialValue={loginC.schoolData.sch_name}>
            <Input
              value={loginC.schoolData.sch_name}
              disabled
              className="custom-input"
            />
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Your date of birth</h2>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please select your birth date",
              },
            ]}
            name="age"
          >
            <DatePicker
              defaultPickerValue={YearBack5}
              disabledDate={disabledDate}
              format="DD-MMM-YYYY"
              className="custom-input"
            />
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Last few things and we are set!!</h2>
          <Form.Item
            name="gender"
            rules={[
              {
                required: true,
                message: "Please select your gender",
              },
            ]}
          >
            <Select placeholder="Gender" className="custom-input">
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
              <Option value="NA">Other</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="grade"
            rules={[
              {
                required: true,
                message: "Please select your grade",
              },
            ]}
          >
            <Select placeholder="Grade" className="custom-input">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, "UG", "PG"].map(
                (data, index) => (
                  <Option
                    key={index}
                    value={data === "UG" ? 13 : data === "PG" ? 14 : data}
                  >
                    {data}
                  </Option>
                ),
              )}
            </Select>
          </Form.Item>

          <Form.Item
            // name="session"
            name="grade_month"
            rules={[
              {
                required: true,
                message: "Please select your session",
              },
            ]}
          >
            <Select placeholder="Session" className="custom-input">
              {/* <Option value="Sep">Sep</Option>
              <Option value="Apr">Apr</Option> */}
              <Option value="9">Sep</Option>
              <Option value="4">Apr</Option>
            </Select>
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Last few things and we are set!!</h2>
          <Form.Item
            name="section"
            rules={[
              {
                required: true,
                message: "Please select your section",
              },
              {
                max: 4,
                message: "value should be less then 4",
              },
            ]}
          >
            <Input placeholder="Section*" className="custom-input" />
          </Form.Item>

          <Form.Item
            name="std_no"
            rules={[
              {
                max: 16,
                message: "Only 16 letters allow to input",
              },
              {
                required: true,
                message: "Please select your student id",
              },
            ]}
          >
            <Input placeholder="Student ID*" className="custom-input" />
          </Form.Item>
        </>
      ),
    },
    {
      content: (
        <>
          <h2>Which country are your from</h2>
          <Form.Item
            name="country_code"
            rules={[
              {
                required: true,
                message: "Please select your country",
              },
            ]}
          >
            <Select placeholder="Country" className="custom-input">
              {country.map((country, index) => {
                return (
                  <Option key={index} value={handleCountryCode(country.code)}>
                    {countryFlagImg(country.code)}
                    {country.code} {country.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </>
      ),
    },
  ];
  return (
    <div className="login-page">
      <div className="login-logo">
        <a href="https://mymemorymentor.com/mappr/">
          <LazyLoadImage alt="" effect="blur" src={logo} />
        </a>
      </div>
      <div className="login-wrapper">
        <div className="login-form">
          <div className="login-form-head">
            <span>Register</span>
          </div>
          <Form
            name="basic"
            style={{ width: "100%" }}
            validateTrigger="onSubmit"
            className="signup-form"
            form={form}
            onFinish={(value) => {
              currentStep < steps.length - 1 && handleNext(value);
              currentStep === steps.length - 1 && handleSubmit(value);
            }}
          >
            <Steps
              current={currentStep}
              progressDot
              size="small"
              className="ant-steps ant-steps-horizontal signup-steps ant-steps-small ant-steps-label-vertical ant-steps-dot"
              // responsive={false}
              direction="horizontal"
            >
              {steps.map((item, index) => (
                <Step key={index} title="" />
              ))}
            </Steps>

            <div className="signup-form__content">
              {steps[currentStep].content}
            </div>

            <div className="signup-buttons">
              {currentStep > 0 && (
                <Button
                  onClick={() => setCurrentStep((prev) => prev - 1)}
                  className="custom-btn signup-btn"
                >
                  ← Back
                </Button>
              )}
              {currentStep < steps.length - 1 && (
                <Form.Item>
                  <Button
                    htmlType="submit"
                    className="custom-btn signup-btn two"
                  >
                    Next →
                  </Button>
                </Form.Item>
              )}
              {currentStep === steps.length - 1 && (
                <Form.Item>
                  <Button
                    htmlType="submit"
                    className="custom-btn signup-btn two"
                  >
                    Submit
                  </Button>
                </Form.Item>
              )}
            </div>
          </Form>
          <SignupModal
            isPolicyModal={isPolicyModal}
            setIsPolicyModal={(value) => setIsPolicyModal(value)}
            handleSignupApi={() => {
              console.log(collectData);
              signUpApi(collectData, dispatchLogin, history);
            }}
          ></SignupModal>
        </div>
        <Footer
          supportData={supportData}
          loader={loader}
          LoadingOutlined={LoadingOutlined}
          dispatchLogin={dispatchLogin}
        />
      </div>
    </div>
  );
}
